const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
  })
})

export default styles



// WEBPACK FOOTER //
// ./src/components/support/styles.js